import React from 'react';
import { useDispatch } from 'react-redux';
import { GridCol, GridRow } from '@naf/grid';
import { Text, TextVariant } from '@naf/text';
import { Button } from '@naf-simba/elements-buttons';
import { actions as userActions } from '@redux/modules/user';
import FinderIllustration from '../../icons/DynamicallyImportedFinderIllustration';
import * as S from '../MegaMenuOverlay.styles';

const MegaMenuOverlayError = ({ menuOffset, isMenuOpen }: { menuOffset: number; isMenuOpen?: boolean }) => {
  const dispatch = useDispatch();
  const handleCloseMenu = React.useCallback(() => {
    dispatch(userActions.closeMenu());
  }, [dispatch]);

  return (
    <S.Wrapper id="site-megamenu" $menuOffset={menuOffset} $isMenuOpen={isMenuOpen}>
      <S.Content>
        <S.StyledGrid>
          <GridRow>
            <GridCol s="12" m="12" l="12" xl="12">
              <S.ErrorWrapper>
                <FinderIllustration />
                <Text variant={TextVariant.Header3} tag="h2">
                  Ooops, noe gikk dessverre galt
                </Text>
                <Text variant={TextVariant.ArticleText}>
                  Vi klarte ikke laste menyen. Vennligst forsøk igjen senere.
                </Text>
                <Button onClick={handleCloseMenu}>Lukk meny</Button>
              </S.ErrorWrapper>
            </GridCol>
          </GridRow>
        </S.StyledGrid>
      </S.Content>
    </S.Wrapper>
  );
};

export default MegaMenuOverlayError;
